export function FancyCheckbox({
  labelId,
  value,
  register,
  children,
}: {
  labelId?: string;
  value: string | boolean;
  register: any;
  children: React.ReactNode;
}) {
  const inputCss =
    "mr-2 " +
    "appearance-none " + // hide the original checkbox
    "before:h-4 before:w-4 before:border before:hover:border-2 before:border-gray-400 before:block before:opactiy-100 before:rounded " + // style when not checked
    "before:hover:border-blue-600 " + // change broder when hover.  make sure no transition duration is applied
    "before:checked:bg-blue-600 before:checked:border-0 " + // style when checked
    "before:transition-[background-color] before:duration-600"; // transition effect when checked

  const labelCss =
    "flex items-center " + // seems like this is the only way I can get both the checkbox and label vertically aligned
    "hover:font-semibold hover:text-blue-600"; // style when hover

  return (
    <label id={labelId} className={labelCss}>
      <input className={inputCss} type="checkbox" value={value} {...register} />
      {children}
    </label>
  );
}
